define((require) => {
    "use strict";

    const $                       = require("jquery");
    const Backbone                = require("backbone");
    const Marionette              = require("marionette");
    const XDomainRequestTransport = require("shared/util/XDomainRequestTransport");

    // For now, force/hack Backbone and Marionette to use our version of jQuery (the current versions still rely on jQuery being globally exposed on the Window object).
    // FIXME: Once we update the below dependencies...
    Backbone.$ = $;
    Marionette.$ = $;

    // For IE browsers not supporting CORS via XMLHttpRequest, add a jQuery transport that uses XDomainRequest
    if (window.XDomainRequest && !("withCredentials" in new XMLHttpRequest())) {
        Backbone.$.ajaxTransport("json", XDomainRequestTransport);
    }

    return Backbone;
});



// WEBPACK FOOTER //
// ./src/shared/zbone/BackboneWrapper.js